import { Moment } from 'moment';
import { Model, ModelClass } from './Model';

export interface DeliveryType extends ModelClass {
    id: number;
    item_id: number;
    factory_id: number;
    expected_delivery_date: Moment;
    status: string;
    completion_time_estimate: Moment;
    completion_time: Moment;
    total: number;
    subtotal: number;
    tax: number;
    deductions_to_factory: number;
    deductions_to_salesman: number;
    shipping_cost: number;
    salesman_commission: number;
    stage_statuses: any[];
    current_stage: any;
}

export const Delivery = Model<DeliveryType>('Delivery', {
    endpoint: 'apparel-deliveries',
})`
    id:Int;
    item_id:Int;
    factory_id:Int;
    expected_delivery_date:DateTime;
    status:String;
    total:Float;
    subtotal:Float;
    tax:Float;
    completion_time_estimate:DateTime;
    completion_time:DateTime;
    deductions_to_factory:Int;
    deductions_to_salesman:Int;
    shipping_cost:Int;
    salesman_commission:Int;
    stage_statuses:Any;
    current_stage:Any;
`;
